export default __webpack_public_path__ + "static/dev-bellwood-6ae909d4bf59c596df0017525fde9808.jpg";